import styled from '@emotion/styled';
import MuiButton from '@material-ui/core/Button';

const Button = styled(MuiButton, {
  shouldForwardProp: (prop) => !['look', 'size', 'fullWidth'].includes(prop),
})`
  color: ${({ look }) => look.color};
  background: ${({ look }) => look.bgColor};
  border: ${({ look }) => look.borderColor};
  padding: ${({ size }) => size.padding};
  justify-content: ${({ size }) => size.justification};

  min-height: ${({ size }) => size.buttonHeight};
  min-width: ${({ size }) => (size.buttonWidth ? size.buttonWidth : '0')};
  ${({ size }) => (size.buttonWidth ? `width: ${size.buttonWidth};` : '')}

  line-height: ${({ size }) => size.text};
  font-size: ${({ size }) => size.text};

  display: inline-flex;

  box-sizing: border-box;
  border-radius: ${({ look }) =>
    look.borderRadius ? look.borderRadius : '4px'};
  font-weight: 500;
  align-items: center;
  text-transform: none;
  transition: color 250ms;

  ${({ fullWidth }) => (fullWidth ? 'width: 100%;' : '')}
  ${({ fullWidth }) => (fullWidth ? 'justify-content: flex-start;' : '')}

  & svg {
    width: ${({ size }) => size.icon};
    height: ${({ size }) => size.icon};

    color: ${({ look }) => look.iconColor};
  }

  &:hover {
    opacity: 1;
    color: ${({ look }) => look.hoverColor};
    background: ${({ look }) => look.hoverBgColor};

    svg {
      color: ${({ look }) => look.hoverIconColor};
    }
  }

  $:focus: {
    border: ${({ look }) => look.focusBorderColor || look.borderColor};
  }

  :disabled,
  :hover:disabled {
    color: ${({ look }) => look.disabledColor || look.hoverColor};
    background: ${({ look }) => look.disabledBgColor || look.hoverBgColor};
    border: ${({ look }) => look.disabledBorderColor || look.borderColor};

    cursor: not-allowed;
    pointer-events: all !important;
  }
`;

export default Button;
